import { DetailSkeleton } from 'components/skeletons';
import React, { useCallback, useEffect, useMemo } from 'react';
import { Box, Button, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { Form } from './form';
import { toast } from 'react-toastify';
import { useGetOffer, useUpdateOffer } from 'core/offers/hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { CardHeader } from 'components/cards/header';

type Props = {
    offerData: any;
};

const EditForm = ({offerData}: Props) => {
    const navigate = useNavigate();

    // Form
    const methods = useForm({mode: 'onChange', defaultValues: useMemo(() => offerData, [offerData])});
    const { formState: { errors, dirtyFields }, reset } = methods;
    const onFormSubmit = (data: any) => mutation.mutate({id: offerData.id, data: data});
    const onReset = useCallback(() => reset(offerData), [offerData, reset]);
    useEffect(() => reset(offerData), [offerData, reset]);

    // Mutation
    const mutation = useUpdateOffer({
        onError: (err) => toast.error("Une Erreur est survenue"),
        onSuccess: (data: any) => {
            toast.success("L'offre a été créee");
            navigate(`/dashboard/offers/${data.id}`);
        }
    });

    return (
        <Box component='main'>
            <FormProvider {...methods}>
                <Box component='form' onSubmit={methods.handleSubmit(onFormSubmit)} noValidate>
                    <CardHeader
                        title={`${offerData.job_title}`}
                        rightComponent={(
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 3, gap: '1rem' }}>
                                <Button variant='contained' color='secondary' onClick={onReset} disabled={mutation.isLoading || Object.keys(dirtyFields).length === 0}>
                                    Annuler
                                </Button>
                                <Tooltip title={Object.keys(errors).length > 0 ? 'Veuillez fixer les erreurs' : (Object.keys(dirtyFields).length === 0 ? 'Aucun champs a été modifié' : "")}>
                                    <span>
                                        <Button type='submit' variant='contained' color='primary' sx={{ color: 'white' }} disabled={mutation.isLoading || Object.keys(errors).length > 0 || Object.keys(dirtyFields).length === 0}>
                                            {mutation.isLoading && <CircularProgress size={10} />}
                                            Sauvegarder
                                        </Button>
                                    </span>
                                </Tooltip>
                            </Box>
                        )}
                    />
                    <Form />
                </Box>
            </FormProvider>
        </Box>
    );
};

const EditPage = () => {
    const {offerId} = useParams();
    const {data: offerData, isLoading} = useGetOffer(Number(offerId!), {onError: (err) => toast.error("Une Erreur est survenue")});

    return (
        <Box>
            {offerData ? (<EditForm offerData={offerData} />) : isLoading ? (<DetailSkeleton />) : (<Typography>Une erreur est survenue</Typography>)}
        </Box>
    );
};

export { EditPage };